<template>
  <DragPanel
    title="开挖"
    :closePanel="closePanel"
    :tooltipVisible="false"
    ref="dom">
    <div class="create-extrude-box">
      <div class="steps-box">
        <div class="step-item-box">
          <div :class="getStepIndexClassName(1)">
            <span class="stepNumber">1</span>
          </div>
          <div :class="getStepNameClassName(1)">区域绘制</div>
        </div>
        <div class="step-connector-line" />
        <div class="step-item-box">
          <div :class="getStepIndexClassName(2)">
            <span class="stepNumber">2</span>
          </div>
          <div :class="getStepNameClassName(2)">属性编辑</div>
        </div>
      </div>
      <div class="common-form-box">
        <el-form
          class="public-form-primary"
          ref="extrudeForm"
          :inline="true"
          :model="extrudeForm"
          :rules="rules"
          label-width="80px">
          <el-form-item
            class="form-item"
            label="名称："
            prop="extrudeName">
            <div class="common-input-box">
              <el-input
                class="input-primary"
                size="small"
                :minlength="1"
                :maxlength="20"
                show-word-limit
                v-model="extrudeForm.extrudeName"
                placeholder="请输入开挖区域名称" />
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div
        class="first-step-box"
        v-show="currStep === 1">
        <div class="create-mode-box">
          <div class="label-box">
            <div class="name dialog-label">绘制方式</div>
            <el-tooltip
              :effect="$theme.tooltipKey()"
              placement="top-start"
              popper-class="common-panel-tooltip-box">
              <div slot="content">
                <div>
                  我们提供两种创建多边形区域的方法：手动绘制和从文件导入。
                </div>
                <div>
                  (1)
                  手动绘制区域：您可以在画布上用鼠标点击来确定多边形的顶点，系统会自动连接这些点形成区域
                </div>
                <div>
                  (2)
                  导入区域文件：如果您已有包含<span>单个多边形</span>顶点信息的文件(支持json或geojson格式),可直接导入，系统将自动解析并显示对应的多边形。
                </div>
                <div>两种方式都能帮助您便捷地创建所需的多边形区域</div>
              </div>
              <div class="icon-box">
                <icon-svg
                  icon-class="ic-jieshishuoming"
                  size="14" />
              </div>
            </el-tooltip>
            <div>:</div>
          </div>
          <div class="common-button-box">
            <el-button
              class="primary-btn gr8"
              size="small"
              type="primary"
              :class="currMode === 'create' ? 'active' : ''"
              @click="createExtrudeByCursor">
              手动绘制区域
            </el-button>
            <ReadFileFromLocal
              :disabled="createSource === 'fromCursor'"
              :handleUploadBtn="handleUploadBtn"
              :onFileLoaded="handleFileLoaded" />
          </div>
        </div>
        <div class="uniform-height-box">
          <div class="label-box">
            <div class="name dialog-label">统一顶点高度</div>
            <el-tooltip
              :effect="$theme.tooltipKey()"
              placement="top-start"
              popper-class="common-panel-tooltip-box">
              <div slot="content">
                在绘制矢量面时，由于手动操作可能存在偏差，各顶点可能出现高低不平的情况。为确保图形平整，您可在完成绘制后使用高度统一功能，一键将所有顶点智能对齐到相同水平面，消除高度误差
              </div>
              <div class="icon-box">
                <icon-svg
                  icon-class="ic-jieshishuoming"
                  size="14" />
              </div>
            </el-tooltip>
            <div>:</div>
          </div>
          <div
            :class="`icon-btn-box ${isPickUpHeightEnable ? 'active' : ''}`"
            @click="pickUpHeight">
            <icon-svg icon-class="icon-shiqubingtongyidingdiangaodu" />
          </div>
        </div>
      </div>
      <div
        class="last-step-box"
        v-show="currStep === 2">
        <div class="item-box">
          <div class="label-box">
            <div class="name">开挖区域可影响的场景对象</div>
            <el-tooltip
              :effect="$theme.tooltipKey()"
              placement="top-start"
              popper-class="common-panel-tooltip-box">
              <div slot="content">
                <div>(1) 右键结束绘制，平台会自动计算哪些数据集被影响。</div>
                <div>(2) 开挖效果仅针对单一数据集。</div>
              </div>
              <div class="icon-box">
                <icon-svg icon-class="ic-jieshishuoming" />
              </div>
            </el-tooltip>
            <div>:</div>
          </div>
        </div>
        <el-scrollbar class="extrude-affect-list">
          <el-radio-group
            v-model="affectedDataSetId"
            @input="handleRadioChange">
            <div
              class="common-radio-box"
              v-for="(item, index) in affectDataSetList"
              :key="index">
              <el-radio
                :label="item.dataSetId"
                class="radio-primary">
                <div v-if="item.isTerrType && item.linkDataSets.length > 1">
                  <div
                    v-for="(element, index) in item.linkDataSets"
                    :key="index"
                    class="link-dataset-box">
                    <div class="link-tip-box">
                      <div class="icon-box">
                        <icon-svg icon-class="ic-lianjieshu" />
                      </div>
                      <div class="link-line" />
                      <div class="layer-name">
                        {{ element.dataSetName }}
                      </div>
                    </div>
                    <div class="link-dataset-line" />
                  </div>
                </div>
                <div
                  v-else
                  class="layer-name"
                  :title="item.dataSetName">
                  {{ item.dataSetName }}
                </div>
              </el-radio>
            </div>
          </el-radio-group>
        </el-scrollbar>
        <div class="item-box">
          <div class="label-box">
            <div class="name dialog-label extrudeMethod">开挖形式</div>
            <el-tooltip
              :effect="$theme.tooltipKey()"
              placement="top-start"
              popper-class="common-panel-tooltip-box">
              <div slot="content">
                <div>开挖支持三种形式：</div>
                <div>(1) 底部开口</div>
                <div>适用数据：倾斜摄影、BIM模型</div>
                <div>(2) 底部封口并使用原纹理</div>
                <div>适用数据：倾斜摄影、遥感影像、WMTS地图服务</div>
                <div>(3) 底部封口并使用指定纹理</div>
                <div>适用数据：倾斜摄影、BIM模型</div>
              </div>
              <div class="icon-box">
                <icon-svg icon-class="ic-jieshishuoming" />
              </div>
            </el-tooltip>
            <div>:</div>
          </div>
          <div class="common-select-box">
            <el-select
              class="primary-select"
              size="small"
              v-model="extrudeType"
              :popper-append-to-body="false"
              @change="handleExtrudeTypeChange">
              <el-option
                v-for="(item, index) in extrudeTypeList"
                :key="index"
                :value="item.value"
                :label="item.name" />
            </el-select>
          </div>
        </div>
        <div
          class="item-box"
          v-if="extrudeType === 2">
          <div class="label-box dialog-label">选择纹理：</div>
          <div class="texture-box">
            <div
              class="curr-texture-box"
              @click.stop="toggleTextureList">
              <!-- prettier-ignore -->
              <div class="img-box" :style="`background-image:url(${getCurrTexture(currTextureId)})`" />
              <div class="icon-box">
                <i class="el-icon-caret-bottom" />
              </div>
            </div>
            <div
              class="texture-select-box"
              v-if="isTextureListVisible">
              <div
                v-for="(item, index) in textureList"
                :key="index"
                class="texture-item-box"
                @click="handleTextureChange(item)">
                <img :src="getCurrTexture(item.textureId)" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="folder-path-box">
        <div class="label-box dialog-label">目标路径：</div>
        <div
          class="muti-line-text-overflow dialog-label"
          :title="getFolderPathName()">
          {{ getFolderPathName() }}
        </div>
      </div>
    </div>
    <div class="operation-box">
      <div
        class="common-button-box btn-group-primary"
        v-if="currStep === 1">
        <el-button
          size="small"
          class="normal-btn gr9 primary-ang-btn"
          @click="clearReg">
          清除区域
        </el-button>
        <el-button
          size="small"
          class="primary-ang-btn primary-btn"
          type="primary"
          @click="nextStep">
          下一步
        </el-button>
      </div>
      <div
        class="common-button-box btn-group-primary"
        v-if="currStep === 2">
        <el-button
          size="small"
          @click="lastStep"
          class="normal-btn gr8 primary-ang-btn">
          上一步
        </el-button>
        <el-button
          size="small"
          type="primary"
          class="primary-ang-btn primary-btn"
          @click="saveExtrude">
          保存
        </el-button>
      </div>
    </div>
  </DragPanel>
</template>

<script>
import * as turf from '@turf/turf'

import DragPanel from '@/components/CustomDragPanel.vue'
import ReadFileFromLocal from '@/components/ReadFileFromLocal.vue'

import { Store } from '@/utils/store'

import { pad2 } from '@/utils/generalMethods'

import {
  createExtrudeService,
  getSingleSceneTreeById
} from '@/service/interface.js'

export default {
  data() {
    const validExtrudeNameRule = (rule, value, callback) => {
      this.isSameNameCheck(value).then(isCheckPass => {
        if (!isCheckPass) {
          callback(new Error('当前场景中存在同名开挖区域，请指定其它名称'))
          return
        }

        if (value.length !== value.trimStart().trimEnd().length) {
          callback(new Error('开头和结尾不允许有空格'))
          return
        }

        callback()
      })
    }

    return {
      currStep: 1,
      activeSteps: [1],

      // 原始开挖名称，用于判断是否修改了开挖名称
      originExtrudeName: '',
      extrudeForm: {
        extrudeName: ''
      },
      extrudeID: '',
      rules: {
        extrudeName: [
          {
            required: true,
            message: '请输入开挖区域名称',
            trigger: 'blur'
          },
          {
            min: 1,
            max: 20,
            message: '输入内容请控制在1到20个字符之间',
            trigger: 'change'
          },
          { validator: validExtrudeNameRule, trigger: 'blur' }
        ]
      },

      // 创建来源(fromCursor: 鼠标绘制, fromFile: 文件导入)
      createSource: '',
      // 当前模式(create:创建, edit:编辑, preview:预览，clear:清除区域, 瞬时状态，防止因响应REAddExtrudeRgnFinish事件弹出提示)
      currMode: '',
      isPickUpHeightEnable: false,

      affectedDataSetId: '',
      affectDataSetList: [],
      extrudeTypeList: [],
      extrudeType: 0,
      currTextureId: '',
      textureList: [],
      isTextureListVisible: false,

      // 当前选中的矢量边，作为是否给出操作提示的依据
      currElemType: '',
      currEdgeId: '',
      originX: -1,
      originY: -1
    }
  },
  props: {
    currDataSetFolder: Object,
    updateSceneTree: Function,
    expandNodeByDataSetType: Function,
    findAllDataSets: Function,
    closeExtrudePanel: Function
  },
  components: {
    DragPanel,
    ReadFileFromLocal
  },
  mounted() {
    this.initExtrudeInfo()

    // prettier-ignore
    document.addEventListener("REAddExtrudeRgnFinish", this.onREAddExtrudeRgnFinish);
    document.addEventListener('RESystemSelElement', this.onSelElement)
    document.addEventListener('RESystemSelShpElement', this.onSelElement)
    // 用于隐藏指定纹理下拉列表
    document.addEventListener('click', this.handleDocumentClick)
    this.addCanvasEventListener()

    this.setPanelStyle()
  },
  beforeDestroy() {
    // prettier-ignore
    document.removeEventListener("REAddExtrudeRgnFinish", this.onREAddExtrudeRgnFinish);
    document.removeEventListener('RESystemSelElement', this.onSelElement)
    document.removeEventListener('RESystemSelShpElement', this.onSelElement)
    // 用于隐藏指定纹理下拉列表
    document.removeEventListener('click', this.handleDocumentClick)
    this.removeCanvasEventListener()

    // 组件销毁时清除计时器
    if (this.saveWaterTimer) {
      clearTimeout(this.saveWaterTimer)
    }
  },
  methods: {
    initExtrudeInfo() {
      let extrudeName = this.getExtrudeDefaultName()
      this.originExtrudeName = extrudeName
      this.extrudeForm.extrudeName = extrudeName

      this.extrudeID = `Extrude_${new Date().getTime()}`

      let textureList = Store.extrudeTextureList
      this.textureList = textureList
      this.currTextureId = this.textureList[0].textureId
    },
    createExtrudeByCursor() {
      this.$refs.extrudeForm.validate((bool, object) => {
        if (bool) {
          if (this.currMode !== '') {
            this.$message.warning('请先清除当前绘制区域，再进行新的绘制操作')
            return
          }

          let camLoc = window.BlackHole3D.Camera.getCamLocate()
          let camPos = camLoc.camPos
          let camHeight = camPos[2]
          if (camHeight > 100000) {
            // prettier-ignore
            this.$message.warning("当前相机高度超过100公里，无法进行打点操作。请降低相机高度后重试。");
            return
          }

          const Extrude = window.BlackHole3D.Extrude

          this.currMode = 'create'
          this.createSource = 'fromCursor'

          Extrude.startEditState()
          Extrude.startAddExtrudeState(this.extrudeID)
        } else {
          // prettier-ignore
          this.$message.error("表单验证失败，请正确填写相关内容后再进行绘制操作");
        }
      })
    },
    handleUploadBtn() {
      this.extrudeType = 0
    },
    handleFileLoaded(fileContent) {
      if (!fileContent) return

      this.drawExtrudeByFile(fileContent)

      const Extrude = window.BlackHole3D.Extrude
      Extrude.startEditState()
      Extrude.setShowState([this.extrudeID], 0)

      Extrude.setCamToData([this.extrudeID])
      this.createSource = 'fromFile'
      this.currMode = 'edit'
    },
    pickUpHeight() {
      if (!this.isValidRegionExist()) {
        this.$message.warning('请先完成有效区域的绘制，再设置统一高度')
        return
      }

      this.isPickUpHeightEnable = true
    },
    clearReg() {
      if (this.currMode === '') {
        this.$message.warning('当前没有可清除的区域，请先进行区域绘制')
        return
      }

      if (!this.isValidRegionExist()) {
        this.$message.warning('请先完成当前区域绘制后，再点击清除区域')
        return
      }

      let warningMsg = '此操作将会清除当前选定区域，是否继续？'
      this.$confirm(warningMsg, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.currMode = 'clear'

          const Extrude = window.BlackHole3D.Extrude

          let extrudeID = this.extrudeID

          Extrude.endAddExtrudeState()
          Extrude.endEditState()

          Extrude.delData([extrudeID])

          this.isPickUpHeightEnable = false
          let coorInfo = { visible: false }
          this.$eventManage.fire('canvasMouseMove', { coorInfo })

          if (this.createSource == 'fromCursor') {
            this.createSource = 'fromCursor'
            this.currMode = 'create'

            Extrude.startEditState()
            Extrude.startAddExtrudeState(extrudeID)
          } else if (this.createSource == 'fromFile') {
            this.createSource = ''
            this.currMode = ''
          }
        })
        .catch(() => {
          this.$message.info('取消清除')
        })
    },
    nextStep() {
      this.$refs.extrudeForm.validate((bool, object) => {
        if (bool) {
          if (this.currMode === '') {
            this.$message.warning('当前没有可编辑的区域，请先进行区域绘制')
            return
          }

          if (this.currMode === 'create') {
            this.$message.warning('请先完成当前区域绘制，再点击下一步')
            return
          }

          const Extrude = window.BlackHole3D.Extrude
          Extrude.endAddExtrudeState()
          Extrude.endEditState()

          let currExtrudeData = Extrude.getData([this.extrudeID])
          let extrudeInfo = currExtrudeData[0]
          let affectDataSetList = this.getAffectDataSetList(extrudeInfo)
          if (affectDataSetList.length) {
            this.affectDataSetList = affectDataSetList

            let find = affectDataSetList.find(
              el => el.dataSetId === this.affectedDataSetId
            )
            let defaultDataSet
            if (find) {
              defaultDataSet = find
            } else {
              defaultDataSet = affectDataSetList[0]
            }
            this.affectedDataSetId = defaultDataSet.dataSetId
            this.setExtrudeTypeListByDataSetType(defaultDataSet.dataSetType)
            this.extrudeType = this.extrudeTypeList[0].value
            Extrude.setShowType(this.extrudeID, this.extrudeType)

            let scopeDataSetIds = []
            if (defaultDataSet.isTerrType) {
              let linkDataSets = defaultDataSet.linkDataSets
              scopeDataSetIds = linkDataSets.map(el => el.resId)
            } else {
              scopeDataSetIds = [defaultDataSet.resId]
            }
            Extrude.setDataSetScope(this.extrudeID, scopeDataSetIds)
          } else {
            Extrude.delData([this.extrudeID])

            this.createSource = ''
            this.currMode = ''

            // prettier-ignore
            this.$message.warning("当前区域没有可影响的数据集，无法进行开挖，请重新绘制或导入区域文件");
            return
          }

          this.currMode = 'preview'

          this.currStep = 2
          if (!this.activeSteps.includes(2)) {
            this.activeSteps.push(2)
          }

          this.setPanelStyle()
        } else {
          // prettier-ignore
          this.$message.error("表单验证失败，请正确填写相关内容后再保存");
        }
      })
    },
    handleRadioChange(value) {
      let find = this.affectDataSetList.find(el => el.dataSetId === value)
      this.setExtrudeTypeListByDataSetType(find.dataSetType)
      this.extrudeType = this.extrudeTypeList[0].value

      const Extrude = window.BlackHole3D.Extrude
      let scopeDataSetIds = []
      if (find.isTerrType) {
        let linkDataSets = find.linkDataSets
        scopeDataSetIds = linkDataSets.map(el => el.resId)
      } else {
        scopeDataSetIds = [find.resId]
      }
      Extrude.setDataSetScope(this.extrudeID, scopeDataSetIds)
      Extrude.setShowType(this.extrudeID, this.extrudeType)

      this.setPanelStyle()
    },
    setExtrudeTypeListByDataSetType(dataSetType) {
      const extrudeTypeList = [
        {
          value: 0,
          name: '底部开口',
          dataSetType: [0, 11]
        },
        {
          value: 1,
          name: '底部封口并使用原纹理',
          dataSetType: [10, 11, 13]
        },
        {
          value: 2,
          name: '底部封口并使用指定纹理',
          dataSetType: [0, 11]
        }
      ]
      this.extrudeTypeList = extrudeTypeList.filter(el =>
        el.dataSetType.includes(dataSetType)
      )
    },
    closePanel() {
      return new Promise(resolve => {
        this.isUnSaveCheck().then(isCheckPass => {
          if (isCheckPass) {
            this.closeExtrudePanel()
            resolve()
            return
          }

          this.$confirm('您编辑的内容未被保存，确定要退出吗？', '提示', {
            confirmButtonText: '保存并退出',
            cancelButtonText: '直接退出',
            distinguishCancelAndClose: true,
            showConfirmButton: this.isValidRegionExist(),
            type: 'warning'
          })
            .then(() => {
              if (!this.isValidRegionExist()) {
                this.exitCreateExtrude(true)
                this.closeExtrudePanel()
                resolve()
                return
              }

              if (this.currStep === 1) {
                this.setExtrudeEffect()
              }

              this.$refs.extrudeForm.validate((bool, object) => {
                if (bool) {
                  this.createExtrude().then(() => {
                    this.updateSceneTree().then(() => {
                      this.expandNodeByDataSetType(24)
                      this.exitCreateExtrude(false)
                      this.$message.success('保存成功')
                      this.closeExtrudePanel()
                      resolve()
                      return
                    })
                  })
                } else {
                  // prettier-ignore
                  this.$message.error("表单验证失败，请正确填写相关内容后再保存");
                }
              })
            })
            .catch(e => {
              if (e === 'cancel') {
                this.exitCreateExtrude(true)
                this.closeExtrudePanel()
                resolve()
                return
              }
            })
        })
      })
    },
    setExtrudeEffect() {
      const Extrude = window.BlackHole3D.Extrude
      Extrude.endAddExtrudeState()
      Extrude.endEditState()

      let extrudeData = Extrude.getData([this.extrudeID])
      let extrudeInfo = extrudeData[0]
      this.affectDataSetList = this.getAffectDataSetList(extrudeInfo)
      let affectDataSet
      let find = this.affectDataSetList.find(
        el => el.dataSetId === this.affectedDataSetId
      )
      if (find) {
        affectDataSet = find
      } else {
        affectDataSet = this.affectDataSetList[0]
        this.affectedDataSetId = affectDataSet.dataSetId
        this.setExtrudeTypeListByDataSetType(affectDataSet.dataSetType)
        this.extrudeType = this.extrudeTypeList[0].value
        Extrude.setShowType(this.extrudeID, this.extrudeType)
      }

      let scopeDataSetIds = []
      if (affectDataSet.isTerrType) {
        let linkDataSets = affectDataSet.linkDataSets
        scopeDataSetIds = linkDataSets.map(el => el.resId)
      } else {
        scopeDataSetIds = [affectDataSet.resId]
      }
      Extrude.setDataSetScope(this.extrudeID, scopeDataSetIds)
    },
    exitCreateExtrude(isRemoveExtrude) {
      // 清除当前模式，防止因调用endAddExtrudeState触发REAddExtrudeRgnFinish事件导致的异常
      this.currMode = ''
      this.createSource = ''

      const Extrude = window.BlackHole3D.Extrude

      let extrudeID = this.extrudeID

      Extrude.endAddExtrudeState()
      Extrude.endEditState()

      if (isRemoveExtrude) {
        Extrude.delData([extrudeID])
      }

      let coorInfo = { visible: false }
      this.$eventManage.fire('canvasMouseMove', { coorInfo })
    },
    isUnSaveCheck() {
      return new Promise(resolve => {
        let isCheckPass = true
        if (this.currMode !== '' && this.currMode !== 'clear') {
          isCheckPass = false
        }

        // prettier-ignore
        let isNameChange = this.originExtrudeName !== this.extrudeForm.extrudeName;
        if (isNameChange) {
          isCheckPass = false
        }

        resolve(isCheckPass)
      })
    },
    lastStep() {
      const Extrude = window.BlackHole3D.Extrude
      Extrude.startEditState()
      Extrude.setShowState([this.extrudeID], 0)
      this.currMode = 'edit'

      this.currStep = 1
      this.setPanelStyle()
    },
    handleExtrudeTypeChange(value) {
      const Extrude = window.BlackHole3D.Extrude
      Extrude.setShowType(this.extrudeID, value)

      this.setPanelStyle()
    },
    saveExtrude() {
      let startInterval = setInterval(() => {
        this.isSaveDisabled = false
        clearInterval(startInterval)
      }, 10000)

      if (!this.isSaveDisabled) {
        this.$refs.extrudeForm.validate((bool, object) => {
          if (bool) {
            this.createExtrude().then(() => {
              this.updateSceneTree().then(() => {
                this.expandNodeByDataSetType(24)
                this.$message.success('保存成功')
                this.closeExtrudePanel()
              })
            })
          } else {
            // prettier-ignore
            this.$message.error("表单验证失败，请正确填写相关内容后再保存");
          }
        })

        this.isSaveDisabled = true
      }
    },
    createExtrude() {
      return new Promise(resolve => {
        const Extrude = window.BlackHole3D.Extrude
        let sceneId = this.$route.query.sceneId
        let extrudeData = Extrude.getData([this.extrudeID])
        let extrudeInfo = extrudeData[0]
        let parentId = this.getParentId()
        let find = this.affectDataSetList.find(
          el => el.dataSetId === this.affectedDataSetId
        )

        let treeNodeIds = {}
        if (find.isTerrType) {
          let linkDataSets = find.linkDataSets
          linkDataSets.forEach(item => {
            treeNodeIds[item.treeNodeId] = true
          })
        } else {
          treeNodeIds[find.treeNodeId] = true
        }

        let findCurrTexture = this.textureList.find(
          el => el.textureId === this.currTextureId
        )
        extrudeInfo.texPath = findCurrTexture.texturePicPath
        extrudeInfo.texSize = [5.0, 5.0]

        let params = {
          sceneId,
          parentId,
          name: this.extrudeForm.extrudeName,
          geojson: JSON.stringify(extrudeInfo),
          digType: this.extrudeType,
          // prettier-ignore
          textureFileDataId: this.extrudeType === 2 ? findCurrTexture.textureGuid : undefined,
          treeNodeIds
        }
        createExtrudeService(params).then(response => {
          if (response.isSuccess) {
            let data = response.data
            Extrude.delData([this.extrudeID])
            extrudeData[0].extrudeId = data.id
            this.extrudeID = data.id

            Extrude.setData(extrudeData)
            resolve(response)
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    drawExtrudeByFile(fileContent) {
      // 校验文件内容合法性
      let isCheckPass = this.checkFile(fileContent)
      if (!isCheckPass) return

      let sourceDataCrs = this.getSourceDataCrs(fileContent)
      let sourceCoordList = this.getCoordList(fileContent)

      // prettier-ignore
      let transformedCoordList = this.getTransformedCoordList(sourceCoordList, sourceDataCrs);

      const BlackHole3D = window.BlackHole3D
      let rgnList = transformedCoordList

      let extrudeInfo = new BlackHole3D.REExtrudeInfo()
      extrudeInfo.dataSetIdList = []
      extrudeInfo.extrudeId = this.extrudeID
      extrudeInfo.type = this.extrudeType
      extrudeInfo.rgnList = [rgnList]

      BlackHole3D.Extrude.setData([extrudeInfo])
    },
    getSourceDataCrs(fileContent) {
      let sourceDataCrs = 'EPSG:4326'

      let features = fileContent.features
      let feature = features[0]

      let properties = feature.properties
      if (properties && properties.crs) {
        sourceDataCrs = properties.crs
      }

      return sourceDataCrs
    },
    getCoordList(fileContent) {
      let coordList = []
      let features = fileContent.features
      let feature = features[0]
      let geometry = feature.geometry
      let properties = feature.properties
      if (geometry.type === 'Polygon') {
        coordList = geometry.coordinates[0]
        coordList = coordList.map((item, index) => {
          if (properties.heights && properties.heights.length) {
            let hight = properties.heights[index]
            item.push(hight)
          } else {
            item.push(0)
          }
          return item
        })
      }

      return coordList
    },
    getTransformedCoordList(sourceCoordList, sourceDataCrs) {
      let transformedCoordList = []

      const Coordinate = window.BlackHole3D.Coordinate
      let engineWorldCrs = Coordinate.getEngineWorldCRS()

      if (engineWorldCrs) {
        sourceCoordList.forEach(item => {
          // prettier-ignore
          let transformedPoint = Coordinate.getTransEngineCoords(false, sourceDataCrs, [item]);
          transformedCoordList.push(transformedPoint[0])
        })
      } else {
        let destCRS = 'EPSG:3857'
        sourceCoordList.forEach(item => {
          item.push(0)
        })

        // prettier-ignore
        transformedCoordList = Coordinate.getTransGeoCoords(sourceDataCrs, destCRS, sourceCoordList);

        transformedCoordList = transformedCoordList.map(item => {
          item.pop()
          return item
        })
      }

      return transformedCoordList
    },
    checkFile(fileContent) {
      let isCheckPass = true
      if (!fileContent) {
        isCheckPass = false
        return
      }

      let features = fileContent.features
      if (features.length > 1) {
        this.$message.error('导入失败，因为该文件包含多个矢量要素')
        isCheckPass = false
        return isCheckPass
      }

      let feature = features[0]
      let geometry = feature.geometry

      // 目前多面在引擎层面支持，但业务层面的还没有设计好，因此暂不支持
      if (this.isMutiPolygon(geometry)) {
        this.$message.error('导入失败，因为该文件包含多个区域')
        isCheckPass = false
        return isCheckPass
      }

      if (this.isPolygonCreationFailed(geometry)) {
        // prettier-ignore
        this.$message.error("导入失败，该文件区域读取失败，读取的点无法组成一个闭合矢量面");
        isCheckPass = false
        return isCheckPass
      }

      return isCheckPass
    },
    isMutiPolygon(geometry) {
      let geometryType = geometry.type
      return geometryType.includes('Polygon') && geometryType !== 'Polygon'
    },
    isPolygonCreationFailed(geometry) {
      let geometryType = geometry.type

      let isFailed = false

      if (geometryType !== 'Polygon') {
        isFailed = true
        return isFailed
      }

      let coordList = geometry.coordinates[0]
      if (coordList.length < 3) {
        isFailed = true
        return isFailed
      }

      isFailed = this.isSelfIntersect(coordList)
      return isFailed
    },
    // 判断是否自相交
    isSelfIntersect(coordList) {
      let polygon = turf.polygon([coordList])
      let kinks = turf.kinks(polygon)

      let features = kinks.features

      let isIntersect = features.length ? true : false
      return isIntersect
    },
    isValidRegionExist() {
      let isExist = true
      if (this.currMode === 'create') {
        return false
      }

      const Extrude = window.BlackHole3D.Extrude
      let currExtrudeData = Extrude.getData([this.extrudeID])
      if (!currExtrudeData.length) {
        isExist = false
        return isExist
      }

      let extrudeInfo = currExtrudeData[0]
      let rgnList = extrudeInfo.rgnList
      let pointList = rgnList[0]
      if (pointList.length < 3) {
        isExist = false
        return isExist
      }

      return isExist
    },
    onREAddExtrudeRgnFinish() {
      if (this.currMode !== 'create') return

      const Extrude = window.BlackHole3D.Extrude

      let errorExtrudeIds = Extrude.getErrorDrawExtrudeIds()
      if (errorExtrudeIds.includes(this.extrudeID)) {
        this.handleInvalidPolygon()
        return
      }

      let currExtrudeData = Extrude.getData([this.extrudeID])
      if (!currExtrudeData.length) {
        this.handleInvalidPolygon()
        return
      }

      this.currMode = 'edit'

      let coorInfo = { visible: false }
      this.$eventManage.fire('canvasMouseMove', { coorInfo })
    },
    handleInvalidPolygon() {
      const Extrude = window.BlackHole3D.Extrude
      this.$message.warning('本次绘制未生成有效多边形，请重新绘制')
      Extrude.delData([this.extrudeID])
      Extrude.startEditState()
      Extrude.startAddExtrudeState(this.extrudeID)
    },
    // 根据开挖区域获取受影响的数据集
    getAffectDataSetList(extrudeInfo) {
      // 将开挖区域顶点格式化，方便turf.js调用
      let rgnList = extrudeInfo.rgnList
      let extrudeRgn = rgnList[0]
      extrudeRgn = extrudeRgn.map(item => {
        return item.slice(0, 2)
      })
      extrudeRgn.push(extrudeRgn[0])

      let dataSets = this.findAllDataSets()

      // 开挖不支持的数据集类型(15:点云, 19:单构件, 21:矢量, 22:二维图纸)
      const unSupportDataSetType = [15, 19, 21, 22]

      // 剔除不支持开挖的数据集类型
      // prettier-ignore
      dataSets = dataSets.filter((el) => !unSupportDataSetType.includes(el.dataSetType));

      const BlackHole3D = window.BlackHole3D

      let affectDataSetList = []
      let extrudeGeoPoints = this.getGeoCoordList(extrudeRgn)
      let extrudePolygon = turf.polygon([extrudeGeoPoints])
      dataSets.forEach(item => {
        let resId = item.dataSetId.replaceAll('-', '')
        let dataSetBV
        if (item.dataSetType === 0) {
          dataSetBV = BlackHole3D.BIM.getTotalBV(resId)
        } else {
          dataSetBV = BlackHole3D.Grid.getDataSetBV(resId)
        }
        // prettier-ignore
        let isDataSetAffected = this.isDataSetAffected(extrudePolygon, dataSetBV);
        let terrId = BlackHole3D.Terrain.getDataSetTerrId(resId)

        if (isDataSetAffected) {
          let obj = {
            dataSetId: item.dataSetId,
            dataSetType: item.dataSetType,
            resId: resId,
            isTerrType: terrId ? true : false,
            treeNodeId: item.nodeId,
            dataSetName: item.nodeName,
            zMax: dataSetBV[5]
          }
          affectDataSetList.push(obj)
        }
      })
      affectDataSetList = affectDataSetList.sort((a, b) => {
        return a.zMax - b.zMax
      })
      affectDataSetList = this.formatAffectDataSetList(affectDataSetList)

      return affectDataSetList
    },
    isDataSetAffected(extrudePolygon, dataSetBV) {
      let leftBottomPoint = [dataSetBV[0], dataSetBV[2], dataSetBV[4]]
      let rightTop = [dataSetBV[1], dataSetBV[3], dataSetBV[5]]

      let bboxPointList = [leftBottomPoint, rightTop]
      let bboxGeoPointList = this.getGeoCoordList(bboxPointList)

      let diagonalLine = turf.lineString(bboxGeoPointList)
      let bbox = turf.bbox(diagonalLine)
      let bboxPolygon = turf.bboxPolygon(bbox)

      // 开挖区域是否包含数据集
      let isWithin = turf.booleanWithin(extrudePolygon, bboxPolygon)
      let isIntersect = turf.booleanIntersects(extrudePolygon, bboxPolygon)

      if (isWithin || isIntersect) {
        return true
      } else {
        return false
      }
    },
    formatAffectDataSetList(affectDataSetList) {
      const BlackHole3D = window.BlackHole3D

      let formatList = []
      let terrDataSetList = affectDataSetList.filter(el => el.isTerrType)
      let terrainGroups = []
      terrDataSetList.forEach(item => {
        let terrId = BlackHole3D.Terrain.getDataSetTerrId(item.resId)
        let dataSetIds = BlackHole3D.Terrain.getTerrSubAllDataSetId(terrId)
        let find = terrainGroups.find(el => el.terrId === terrId)
        if (!find) {
          let obj = {
            terrId,
            linkDataSets: []
          }
          dataSetIds.forEach(el => {
            let findDataSet = affectDataSetList.find(data => data.resId === el)
            if (findDataSet) {
              obj.linkDataSets.push(findDataSet)
            }
          })
          obj.linkDataSets = obj.linkDataSets.sort((a, b) => {
            return a.zMax - b.zMax
          })

          let defaultDataSet = obj.linkDataSets[0]
          obj.dataSetId = defaultDataSet.dataSetId
          obj.dataSetType = defaultDataSet.dataSetType
          obj.resId = defaultDataSet.resId
          obj.isTerrType = defaultDataSet.isTerrType
          obj.treeNodeId = defaultDataSet.nodeId
          obj.dataSetName = defaultDataSet.dataSetName
          obj.zMax = defaultDataSet.zMax

          terrainGroups.push(obj)
        }
      })

      let notTerrDataSetList = affectDataSetList.filter(el => !el.isTerrType)
      formatList = [...notTerrDataSetList, ...terrainGroups]
      formatList = formatList.sort((a, b) => {
        return a.zMax - b.zMax
      })

      return formatList
    },
    // 处理元素点击事件(包括普通数据和矢量数据点击)，用于拾取高度
    onSelElement(eventInfo) {
      if (this.currMode === 'create') return

      const BlackHole3D = window.BlackHole3D
      let currProbeRet = BlackHole3D.Probe.getCurCombProbeRet()
      let { elemType, elemId } = currProbeRet

      if (this.currEdgeId === elemId) {
        this.currElemType = ''
        this.currEdgeId = ''
        return
      }

      if (elemType === 'ShapeElem') {
        if (elemId && elemId.includes('EXTRUDE_EDGE')) {
          // this.$message.info("再次点击选中边可以添加中点");

          this.currElemType = 'EXTRUDE_EDGE'
          this.currEdgeId = elemId
        } else {
          this.currElemType = ''
        }
      } else {
        this.currElemType = ''
        this.currEdgeId = ''
      }

      if (!this.isPickUpHeightEnable) return

      // 右键取消拾取高度
      let eventDetail = eventInfo.detail
      if (eventDetail.button === 1) {
        this.isPickUpHeightEnable = false

        let coorInfo = { visible: false }
        this.$eventManage.fire('canvasMouseMove', { coorInfo })
        return
      }

      let currPos = currProbeRet.elemPos
      if (currPos.length) {
        let height = Number(currPos[2].toFixed(2))

        const Extrude = window.BlackHole3D.Extrude

        let extrudeData = Extrude.getData([this.extrudeID])
        let extrudeInfo = extrudeData[0]
        let rgnList = extrudeInfo.rgnList
        let pointList = rgnList[0]
        pointList.forEach(point => {
          point[2] = height
        })

        Extrude.setData(extrudeData)

        Extrude.endAddExtrudeState()
        Extrude.endEditState()

        Extrude.startEditState()
        Extrude.setShowState([this.extrudeID], 0)
      }

      this.isPickUpHeightEnable = false

      let coorInfo = { visible: false }
      this.$eventManage.fire('canvasMouseMove', { coorInfo })
    },
    toggleTextureList() {
      this.isTextureListVisible = !this.isTextureListVisible
    },
    handleTextureChange(textureInfo) {
      const Extrude = window.BlackHole3D.Extrude

      let textureId = textureInfo.textureId
      if (textureId !== this.currTextureId) {
        this.currTextureId = textureId
        Extrude.setExtrudeTexId(this.extrudeID, textureId)
      }
    },
    handleDocumentClick() {
      this.isTextureListVisible = false
    },
    addCanvasEventListener() {
      let domRef = null
      if (window.BlackHole3D) {
        domRef = window.BlackHole3D.canvas
      } else {
        domRef = document.getElementById('engineCanvas')
      }
      domRef.addEventListener('click', this.onCanvasClick)
      domRef.addEventListener('mouseup', this.onCanvasMouseUp)
      domRef.addEventListener('mousemove', this.onCanvasMouseMove)
      domRef.addEventListener('mouseleave', this.onCanvasMouseLeave)
    },
    removeCanvasEventListener() {
      let domRef = null
      if (window.BlackHole3D) {
        domRef = window.BlackHole3D.canvas
      } else {
        domRef = document.getElementById('engineCanvas')
      }
      domRef.removeEventListener('click', this.onCanvasClick)
      domRef.removeEventListener('mouseup', this.onCanvasMouseUp)
      domRef.removeEventListener('mousemove', this.onCanvasMouseMove)
      domRef.removeEventListener('mouseleave', this.onCanvasMouseLeave)
    },
    onCanvasClick(eventInfo) {
      // 由于canvaClick事件早于RESystemSelShpElement事件触发，因此增加延迟，以获取RESystemSelShpElement事件中拿到的数据
      setTimeout(() => {
        if (this.currElemType === 'EXTRUDE_EDGE' && this.currEdgeId) {
          this.originX = eventInfo.clientX
          this.originY = eventInfo.clientY

          let coorInfo = {
            visible: true,
            tipContent: '再次点击选中边可以添加中点',
            clientX: eventInfo.clientX,
            clientY: eventInfo.clientY
          }
          this.$eventManage.fire('canvasMouseMove', { coorInfo })
        } else {
          this.originX = -1
          this.originY = -1
          let coorInfo = { visible: false }
          this.$eventManage.fire('canvasMouseMove', { coorInfo })
        }
      }, 300)
    },
    onCanvasMouseUp(eventInfo) {
      let deletaX = eventInfo.clientX - this.originX
      let deletaY = eventInfo.clientY - this.originY
      if (Math.abs(deletaX) > 5 && Math.abs(deletaY) > 5) {
        this.currElemType = ''
      }
    },
    onCanvasMouseMove(event) {
      if (this.currElemType === 'EXTRUDE_EDGE' && this.currEdgeId) {
        if (this.originX !== -1 && this.originY !== -1) {
          let deletaX = event.clientX - this.originX
          let deletaY = event.clientY - this.originY
          if (Math.abs(deletaX) > 5 && Math.abs(deletaY) > 5) {
            this.originX = -1
            this.originY = -1
            let coorInfo = { visible: false }
            this.$eventManage.fire('canvasMouseMove', { coorInfo })
          }
        }
        return
      }

      if (!this.isPickUpHeightEnable && this.currMode !== 'create') return

      let tipContent = ''

      if (this.isPickUpHeightEnable) {
        tipContent = '左键拾取高度并应用，右键取消'
      } else {
        tipContent = '左键绘制，右键结束'
      }

      let coorInfo = {
        visible: true,
        tipContent,
        clientX: event.clientX,
        clientY: event.clientY
      }
      this.$eventManage.fire('canvasMouseMove', { coorInfo })
    },
    onCanvasMouseLeave() {
      let coorInfo = { visible: false }
      this.$eventManage.fire('canvasMouseMove', { coorInfo })
    },
    setPanelStyle() {
      this.$nextTick(() => {
        let domRef = this.$refs.dom.$el
        let panelHeaderDom = domRef.querySelector('.header-box')
        let panelContentDom = domRef.querySelector('.content')
        let height = panelHeaderDom.offsetHeight + panelContentDom.offsetHeight

        domRef.style.height = `${height}px`
        domRef.style.minHeight = `${height}px`
      })
    },
    getGeoCoordList(sourceCoordList) {
      const Coordinate = window.BlackHole3D.Coordinate
      const targetDataCrs = 'EPSG:4326'

      let transformedCoordList = []
      let engineWorldCrs = Coordinate.getEngineWorldCRS()
      if (engineWorldCrs) {
        sourceCoordList.forEach(item => {
          // prettier-ignore
          let point = Coordinate.getTransEngineCoords(true, targetDataCrs, [item]);
          transformedCoordList.push(point[0])
        })
      } else {
        let destCRS = 'EPSG:3857'
        sourceCoordList.forEach(item => {
          item.push(0)
        })
        // prettier-ignore
        transformedCoordList = Coordinate.getTransGeoCoords(destCRS, targetDataCrs, sourceCoordList);
      }

      transformedCoordList = transformedCoordList.map(item => {
        return item.slice(0, 2)
      })

      return transformedCoordList
    },
    getExtrudeDefaultName() {
      let date = new Date()

      let year = date.getFullYear()
      let month = pad2(date.getMonth() + 1)
      let day = pad2(date.getDate())
      let hour = pad2(date.getHours())
      let minute = pad2(date.getMinutes())
      let second = pad2(date.getSeconds())

      let extrudeName = `开挖区域-${year}${month}${day}${hour}${minute}${second}`
      return extrudeName
    },
    getFolderPathName() {
      let folderPathName = ''

      let { nodeType, dataSetType } = this.currDataSetFolder
      if (dataSetType && dataSetType === 24) {
        // prettier-ignore
        folderPathName = nodeType !== 3 ? this.currDataSetFolder.levelPathName : '开挖根目录';
      } else {
        folderPathName = '开挖根目录'
      }

      return folderPathName
    },
    getParentId() {
      let parentId

      let dataSetType = this.currDataSetFolder.dataSetType
      if (dataSetType && dataSetType === 24) {
        parentId = this.currDataSetFolder.nodeId
      }

      return parentId
    },
    isSameNameCheck(extrudeName) {
      return new Promise(resolve => {
        let sceneId = this.$route.query.sceneId
        getSingleSceneTreeById({ sceneId }).then(response => {
          if (response.isSuccess) {
            let data = response.data
            let leafNodes = this.findNodesByNodeType(data, 2)
            let extrudeList = leafNodes.filter(item => {
              return item.dataSetType === 24
            })
            let find = extrudeList.find(item => {
              return item.sceneNodeName === extrudeName
            })

            let isCheckPass = find ? false : true
            resolve(isCheckPass)
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    findNodesByNodeType(data, nodeType) {
      const array = []

      const traverse = item => {
        if (item.nodeType === nodeType) {
          array.push(item)
        }
        if (item.subNodes && item.subNodes.length) {
          item.subNodes.forEach(subNode => {
            traverse(subNode)
          })
        }
      }

      data.forEach(item => {
        traverse(item)
      })

      return array
    },
    getCurrTexture(textureId) {
      let find = this.textureList.find(el => el.textureId === textureId)
      return find.texturePicPath
    },
    getStepIndexClassName(step) {
      let className = 'step-index-box dialog-label'
      if (this.activeSteps.includes(step)) {
        className += ' actived'
      }

      if (this.currStep === step) {
        className += ' active'
      }
      return className
    },
    getStepNameClassName(step) {
      let className = 'step-name-box dialog-label'
      if (this.currStep === step) {
        className += ' active'
      }
      return className
    },
    // 打开其他面板前给出提示
    openOtherPanelCheck() {
      return new Promise(resolve => {
        // prettier-ignore
        let isNameChange = this.originExtrudeName !== this.extrudeForm.extrudeName;
        if (this.currMode === '' && !isNameChange) {
          this.closeExtrudePanel()
          resolve(true)
        } else {
          // prettier-ignore
          let message = '当前正在创建开挖，请先结束创建再执行相关操作';
          let options = {
            message,
            type: 'warning',
            duration: 5000,
            showClose: true
          }
          this.$message(options)
          resolve(false)
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
.common-drag-panel {
  left: 6px;
  top: 6px;
  width: 360px;
  height: unset;
  min-width: 360px;

  .create-extrude-box {
    padding: 8px 15px 5px 15px;

    .steps-box {
      display: flex;
      border-radius: 5px;

      .step-item-box {
        display: flex;
        align-items: center;
        flex-shrink: 0;
        font-size: 14px;

        .stepNumber {
          margin-bottom: 1px;
        }

        .step-index-box {
          width: 16px;
          height: 16px;
          font-size: 12px;
          border: 1px solid var(--extrude-step-line);
          border-radius: 50%;
          line-height: 16px;
          display: flex;
          align-items: center;
          justify-content: center;

          &.active.actived {
            color: var(--aside-bg-color);
            border-color: var(--base-primary-color);
            background-color: var(--base-primary-color);
          }

          &.actived {
            color: var(--extrude-step-text-color);
            border-color: var(--extrude-step-line);
          }
        }

        .step-name-box {
          margin-left: 10px;
          color: var(--extrude-step-text-color);

          &.active.actived {
            color: var(--extrude-step-text-color);
          }

          &.active {
            color: var(--base-primary-color);
          }
        }
      }

      .step-connector-line {
        flex-grow: 1;
        margin: auto 10px;
        height: 2px;
        background: var(--extrude-step-line);
      }
    }

    .common-form-box {
      margin-top: 15px;
      margin-left: -15px;

      :deep(.el-form-item) {
        display: flex;

        &.is-error {
          .el-input__inner {
            border-color: var(--error-status-color);
          }
        }

        .el-form-item__content {
          flex-grow: 1;

          .el-form-item__error {
            color: var(--error-status-color);
            font-size: 10px;
            padding-top: 2px;
            letter-spacing: 1px;
          }
        }
      }
    }

    .first-step-box {
      margin-top: 15px;

      .create-mode-box {
        display: flex;
        align-items: center;

        .label-box {
          display: flex;
          align-items: center;
          flex-shrink: 0;

          .name {
            font-size: 14px;
          }

          .icon-box {
            margin: 0px 3px;

            span {
              margin-top: 2px;
            }
          }
        }

        .common-button-box {
          display: flex;
          margin-left: 10px;
          flex-grow: 1;

          .read-file-box {
            display: flex;
            flex: 1;
            margin-right: 0px;

            :deep(.file-upload-btn) {
              flex: 1;
              padding-left: 8px;
              padding-right: 8px;
              background-color: var(--extrude-texture-fillloadbtn-bgColor) !important;
              border-color: var(--extrude-texture-fillloadbtn-border-color);

              &:hover {
                background-color: var(
                  --extrude-texture-fillloadbtn-hover-bgColor
                ) !important;
                color: var(--extrude-texture-fillloadbtn-hover-text-color) !important;
                border-color: var(--extrude-texture-fillloadbtn-hover-border-color) !important;
              }
            }
          }

          .el-button {
            flex: 1;
            text-align: center;
            border-radius: 4px;
            padding-left: 8px;
            padding-right: 8px;
            :deep(span) {
              display: inline-block;
            }
          }
        }
      }

      .uniform-height-box {
        display: flex;
        margin-top: 15px;
        align-items: center;

        .label-box {
          display: flex;
          align-items: center;
          flex-shrink: 0;

          .name {
            font-size: 14px;
          }

          .icon-box {
            margin: 0px 3px;

            span {
              margin-top: 2px;
            }
          }
        }

        .icon-btn-box {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 32px;
          height: 32px;
          margin-left: 10px;
          border-radius: 4px;
          color: var(--extrude-texture-drawbtn-icon-color);
          cursor: pointer;
          background: var(--extrude-texture-drawbtn-bgColor);
          border: 1px solid var(--extrude-texture-drawbtn-boder-color);

          &.active {
            background: var(--extrude-texture-drawbtn-hover-bgColor);
          }

          &:hover {
            background: var(--extrude-texture-drawbtn-hover-bgColor);
          }
        }
      }
    }

    .last-step-box {
      margin: 10px 0px;
      font-size: 14px;

      .item-box {
        display: flex;
        align-items: center;
        margin-top: 15px;

        &:first-child {
          margin-top: 0px;
        }

        .label-box {
          display: flex;
          align-items: center;

          .icon-box {
            margin: 0px 5px;
          }
        }

        .texture-box {
          position: relative;
          border: 1px solid var(--extrude-texture-border-color);

          .curr-texture-box {
            display: flex;
            align-items: center;
            background: var(--extrude-texture-btn-bgColor);
            cursor: pointer;

            .img-box {
              width: 30px;
              height: 30px;
              background-size: cover;
              background-position: center;
            }

            .icon-box {
              margin: auto;
              font-size: 14px;
              color: var(--extrude-texture-btn-color);
            }
          }

          .texture-select-box {
            position: absolute;
            top: 33px;
            display: grid;
            grid-template-columns: repeat(5, 1fr);
            width: 215px;
            background: var(--input-bg-color);
            border-radius: 8px;
            border: 1px solid var(--extrude-texture-item-border-color);
            padding: 10px;
            gap: 10px;

            .texture-item-box {
              width: 30px;
              height: 30px;
              border: 1px solid var(--extrude-texture-item-border-color);
              border-radius: 3px;
              cursor: pointer;

              img {
                width: 100%;
                height: 100%;
                object-fit: contain;
                border-radius: 3px;
              }
            }
          }
        }

        .common-select-box {
          flex-grow: 1;
          text-align: left;
          margin-left: 10px;

          .primary-select {
            width: 100%;
          }

          :deep(.el-input__inner) {
            width: 100%;
          }
        }
      }

      .extrudeMethod {
        white-space: nowrap;
      }

      .extrude-affect-list {
        height: 120px;
        margin-top: 15px;
        padding: 10px;
        color: var(--default-color);
        border-radius: 8px;
        text-align: left;
        overflow: hidden;
        border: 1px solid var(--extrude-step-footer-border-color);
        background: var(--input-bg-color);

        :deep(.el-scrollbar__wrap) {
          overflow-x: hidden;
          overflow-y: auto;
          // 兼容firefox浏览器
          scrollbar-width: none;

          &::-webkit-scrollbar {
            display: none;
          }
        }

        :deep(.el-radio-group) {
          width: 100%;
          padding-top: 2px;
        }

        .common-radio-box {
          margin-bottom: 5px;

          .link-dataset-box {
            &:last-child {
              .link-dataset-line {
                display: none;
              }
            }

            .link-tip-box {
              display: flex;
              align-items: center;

              .link-line {
                width: 10px;
                height: 1px;
                margin: 0px 2px;
                border: 1px dashed var(--base-border-dark-color19);
              }
            }

            .link-dataset-line {
              height: 10px;
              width: 1px;
              margin: 1px 6px;
              border: 1px dashed var(--base-border-dark-color19);
            }
          }

          .layer-name {
            margin-top: -3px;
          }
        }
      }
    }

    .folder-path-box {
      display: flex;
      align-items: center;
      margin-top: 20px;
      color: var(--input-bg-color);
      font-size: 14px;
    }
  }

  .operation-box {
    border-top: 1px solid var(--extrude-step-footer-border-color);
    padding: 15px;

    .common-button-box {
      display: flex;
      justify-content: end;
    }
  }
}
</style>
